var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 22,
    viewBox: "0 0 37 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 11.3197L0.75 11.5697H1L34.0313 11.5697L24.9336 20.331L24.7466 20.5111L24.9336 20.6912L25.4413 21.1801L25.6147 21.3471L25.7881 21.1801L36.1734 11.1788L36.3604 10.9988L36.1734 10.8187L35.6657 10.3298L35.4923 10.1628L35.491 10.164L25.7881 0.819925L25.6147 0.652922L25.4413 0.819925L24.9336 1.30885L24.7466 1.48892L24.9336 1.669L33.9773 10.3783L1 10.3783H0.75V10.6283L0.75 11.3197Z",
    fill: "#878B93",
    stroke: "#878B93",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrow);
export default __webpack_public_path__ + "static/media/ic-arrow.bc15a0fad411012ee0a5ae3f4fdc05dd.svg";
export { ForwardRef as ReactComponent };